var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',_vm._b({},'span',_vm.$attrs,false),[_vm._t("default",null,{"days":_vm.days,"hours":_vm.hours,"minutes":_vm.minutes,"seconds":_vm.seconds})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }